// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LgpdTerms_ActivateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /lgpd_terms/activate
 *
 * Returns the ID of the now-active LGPD term.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface LgpdTerms_ActivateResponseDados {
id: number
}

export type LgpdTerms_ActivateResponse = ApiResponse<LgpdTerms_ActivateResponseDados>;

registerResponseContract('LgpdTerms_ActivateResponse', {
  id: { type: 'number',  required: true },
})
